export default class {
	static groupBy(arr, selector) {
		let grouped = {};
		for (let index = 0; index < arr.length; index++) {
			const item = arr[index];
			const val = selector(item);
			grouped[val] = grouped[val] || [];
			grouped[val].push(item);
		}
		return grouped;
	}

	/*
      This will group the array by a value that is recieved from func. Allows some custom logic to pass into the group by.
   */
	static groupByAlt(arr, func) {
		let grouped = [];
		arr.forEach(a => {
			let s = func(a);
			grouped[s] = grouped[s] || [];
			grouped[s].push(a);
		});
		return grouped;
	}

	/**
	 * Turn an object into an array of propnames
	 * @param {object} obj
	 */
	static objectPropsToArray(obj) {
		let rtns = [];
		for (var prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				rtns.push(prop);
			}
		}
		return rtns;
	}

	static removeDuplicates(myArr, selector = x => x) {
		return myArr.filter((obj, pos, arr) => {
			return arr.map(mapObj => selector(mapObj)).indexOf(selector(obj)) === pos;
		});
	}

	static mapProps(obj, action) {
		let rtns = [];
		let index = 0;
		for (var prop in obj) {
			if (obj.hasOwnProperty(prop)) {
				rtns.push(action(obj[prop], prop, index++));
			}
		}
		return rtns;
	}
	static sort(arr, selector = x => x, reverse = false) {
		const dir = reverse ? -1 : 1;
		arr.sort((a, b) => {
			let aval = selector(a);
			let bval = selector(b);

			if (typeof aval === "boolean") {
				if (aval && !bval) {
					return -1 * dir;
				} else if (bval && !aval) {
					return 1 * dir;
				} else {
					return 0;
				}
			}

			//remove commas from string formated ints. so parseFloat works
			let t_aval = parseFloat(tryReplace(aval, ",", ""));
			let t_bval = parseFloat(tryReplace(bval, ",", ""));

			if (!isNaN(t_aval) || !isNaN(t_bval)) {
				//is number data
				if (t_aval < t_bval || isNaN(t_bval)) {
					return -1 * dir;
				}
				if (t_aval > t_bval || isNaN(t_aval)) {
					return 1 * dir;
				}
			} else if (aval && !bval) {
				//sort null items to end
				return -1;
			} else if (bval && !aval) {
				//sort null items to end
				return 1;
			} else if (typeof aval === "string") {
				//compare as string
				return aval.localeCompare(bval) * dir;
			} else if (typeof bval === "string") {
				//compare as string
				return bval.localeCompare(aval) * dir;
			} else if (aval == bval) {
				// double == soft compare
				return 0;
			} else {
				let result = aval > bval;
				result = reverse ? !result : result;
				return result ? 1 : -1;
			}
			return 0;
		});
		return arr;
	}
	static fill(count, factory) {
		let rtns = [];
		for (let index = 0; index < count; index++) {
			rtns.push(factory(index));
		}
		return rtns;
	}

	static selectMany(arr, selector = x => x) {
		return arr.reduce((prev, next) => prev.concat(selector(next)), []);
	}
}

function tryReplace(item, from, to) {
	if (typeof item === "string") {
		return item.replace(from, to);
	} else {
		return item;
	}
}



// WEBPACK FOOTER //
// ./src/utils/array.js